import { FormaPgtoRequestV1 } from "./forma-pgto.model";
import { PessoaModel } from "./pessoa.model";
import { VendasDetalheModel } from "./vendas-detalhe.model";

export class PagarContaRequest {
  constructor(
    public numeroComanda: number,
    public codigoCaixaCab: number,
    public codigoFormaPgto: number,
    public valorPago: number
  ) { }
}

export class PedidoBalcaoResponse {
  public dataHoraPedido: string;
  public grupo: string;
  public nomeCliente: string;
  public numeroComanda: number;
  public statusPedido: string;
}

export class PedidoDeliveryResponse {
  public dataHoraPedido: string;
  public empresa: string;
  public enderecoCliente: string;
  public grupo: string;
  public nomeCliente: string;
  public numeroComanda: number;
  public statusPedido: string;
  public telefones: Array<string>;
}

export class PedidoModel {
  public codigoCabCaixa: number;
  public bandeiraCartao?: string;
  public cliente?: PessoaModel = new PessoaModel();
  public codigoEmpresa: number;
  public codigoEndereco?: number;
  public dets: VendasDetalheModel[] = [];
  public formaPgtoDelivery?: 'Dinheiro' | 'Cartao' | 'Pix';
  public FormaPgtoOldV1: FormaPgtoRequestV1 = new FormaPgtoRequestV1();
  public numeroComanda: number;
  public obsPgto?: string;
  public troco?: number;
  public valorRecebido?: number;
  public dataHora: Date = null;
  public terminalId: string = '';

  constructor(init?: Partial<PedidoModel>) {
    Object.assign(this, init);
  }
}

export class PedidoResponse {
  public agora: Date;
  public codigoDet: number;
  public numeroComanda: number;
  public tipo: string;
}

export class PgtoPedidoResponse {
  public codigo: number;
  public formaPgto: string;
  public operacao: number;
  public nomeOperacao: string;
  public valor: number;
}

export class RejeitarPedidoRequest {
  constructor(
    public numeroComanda: number,
    public motivoRejeicao: string
  ) { }
}

export class TransferenciaMesaRequest {
  constructor(
    public numeroComanda: number,
    public numeroComandaDestino: number,
    public codigosVendasDet: number[]
  ) { }
}
